module.exports = __webpack_public_path__ + "static/media/success.346c2b84.svg";